import { render, staticRenderFns } from "./createactivitylist.vue?vue&type=template&id=2fbac588"
import script from "./createactivitylist.vue?vue&type=script&lang=js"
export * from "./createactivitylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports